import { yup } from '@/libs/yup';

export const schema = yup.object({
  stressCheck: yup.boolean(),
  stressCheckRole: yup
    .string()
    .nullable()
    .when('stressCheck', {
      is: true,
      then: schema => schema.required('あなたの役割を選択してください'),
      otherwise: schema => schema.transform(() => undefined)
    }),
  regularHealthCheckup: yup.boolean()
});

export type Schema = yup.InferType<typeof schema>;
